import styles from "./ThroughYears.module.css";
import AchievementItem from "./AchievementItem/AchievementItem";

const ThroughYears = () => {
  const achievementList = [
    {
      title: "1927 - 1947: Оснивање, раст и престанак рада Аеропута",
      content: [
        {
          header: "1927",
          text: "У јуну је основано Друштво за ваздушни саобраћај Аеропут. Национални авио-превозник Краљевине Срба, Хрвата и Словенаца, а потом Краљевине Југославије, Аеропут је био међу првим цивилним авио-компанијама - 10. у Европи и 21. у свету.",
        },
        {
          header: "1928",
          text: "Успостављена је редовна авио-линија између Београда и Загреба.",
        },
        {
          header: "1936",
          text: "Први пут полеће аеро такси ММС-3, јединствена летелица коју је произвео Аеропут.",
        },
        {
          header: "1938",
          text: "Аеропут организује Прву међународну ваздухопловну изложбу на Београдском сајму у оквиру које учествују Чехословачка, Енглеска, Француска, Холандија, Немачка, Пољска, Америка и друге земље.",
        },
        {
          header: "1941",
          text: "Други светски рат уништио је пословање Аеропута: пилоти и летелице мобилисани су у ратну авијацију, а током бомбардовања Београда, флота Аеропута тешко је настрадала.",
        },
        {
          header: "1942",
          text: "Окупационе власти забрањују рад Аеропута.",
        },
      ],
    },
    {
      title: "1947 - 1960: Оснивање ЈАТ-а и раст флоте",
      content: [
        {
          header: "1947",
          text: 'Традицију Аеропута наставља Југословенски аеротранспорт (ЈАТ). У априлу полећу авиони на првим послератним линијама новоосноване компаније. Флоту ЈАТ-а у почетку су чинили два авиона Ц-47 претворена у ДЦ-3 и два "јункерса" ЈУ-52. Прве редовне линије биле су југословенске, Београд-Загреб-Љубљана и Загреб-Сарајево, као и међународна линија Београд-Праг-Варшава.',
        },
      ],
    },
    {
      title: "1960 - 1970: Ера млазне авијације и експанзија",
      content: [
        {
          header: "1963",
          text: 'Прва "каравела" слеће на аеродром у Београду, чиме почиње ера млазне авијације у Југославији. У наредном периоду из флоте се повлаче последњи ветерани клипне флоте ДЦ-3 и "конвери".',
        },
        {
          header: "1967",
          text: "ЈАТ покреће сопствени кетеринг који ће касније користити и Аир Франце.",
        },
        {
          header: "1969",
          text: "Први ДЦ-9 придружује се ЈАТ-овој флоти, а ускоро и први Б-707.",
        },
      ],
    },
    {
      title: "1970 - 1980: Почетак златног доба",
      content: [
        {
          header: "1971",
          text: "ЈАТ постаје чланица Удружења европских ваздухопловних превозилаца (АЕА).",
        },
        {
          header: "1974",
          text: "Током новембра 1974. године ЈАТ-ов Б-707 креће на пут око света рутом Београд-Бејрут-Бомбај-Сингапур-Токио-Хонолулу-Лос Анђелес-Лондон-Београд.",
        },
        {
          header: "1978",
          text: 'У ЈАТ-ову флоту стиже Даглас ДЦ-10-30" (ДЦ-10), први широкотрупни авион. Из Београда се од тада директно летело у Чикаго, Торонто, Њујорк, Лос Анђелес, Сингапур, Куала Лумпур, Пекинг, Сиднеј и Мелбурн.',
        },
      ],
    },
    {
      title: "1980 - 1990: ЈАТ је више од летења!",
      content: [
        {
          header: "1985",
          text: 'ЈАТ је био прва авио-компанија у Европи која је купила у то време најсавременије, а касније најпродаваније летилице типа "Боеинг 737-300" (Б737-300).',
        },
        {
          header: "1987",
          text: "Према ИАТА и АЕА листама највећих авио-превозника, ЈАТ заузима 31. место у свету, односно 10. место у Европи. Крајем златних осамдесетих ЈАТ је повезивао Југославију са 61 светском дестинацијом на пет континената. Годишње је превозио више од пет милиона путника и 46 хиљада тона робе посредством флоте од 36 авиона.",
        },
      ],
    },
    {
      title: "1990 - 2000: Рат и криза ЈАТ-а",
      content: [
        {
          header: "1990",
          text: "Почетком деведесетих година прошлог века започиње најтежи период после Другог светског рата у историји бивше Југославије. Довео је до рата, распада земље и санкција, којима је прво и најтеже била погођена управо национална авио-компанија.",
        },
        {
          header: "1992",
          text: "ЈАТ последњи пут лети за Њујорк у мају, јер само два дана касније САД уводе ембарго на ваздушни саобраћај са Југославијом. Непосредно затим Уједињене нације уводе економске санкције, а ЈАТ у јуну уводи аутобуске линије за Будимпешту и Темишвар.",
        },
      ],
    },
    {
      title: "2000 - 2013: Јат Еирвејс и потрага за стратешким партнером",
      content: [
        {
          header: "2003",
          text: "Јат Еирвејс био је један од првих авио-превозника који је 2005. године добио ИАТА сертификат о безбедности.",
        },
        {
          header: "2005",
          text: "ЈАТ последњи пут лети за Њујорк у мају, јер само два дана касније САД уводе ембарго на ваздушни саобраћај са Југославијом. Непосредно затим Уједињене нације уводе економске санкције, а ЈАТ у јуну уводи аутобуске линије за Будимпешту и Темишвар.",
        },
        {
          header: "2006",
          text: "Први пут после 15 година, национална авио-компанија завршава пословну годину са позитивним резултатом. Ипак, у наредним годинама Јат Еирвејс покушава да пронађе стратешког партнера како би себи обезбедио будућност.",
        },
      ],
    },
    {
      title: "2013 - данас: Стратешко партнерство и ново поглавље",
      content: [
        {
          header: "2013",
          text: "1. августа, национални авио-превозник Уједињених Арапских Емирата Етихад Еирвејс, Јат Еирвејс и Влада Републике Србије објављују стратешко партнерство. Етихад Еирвејс купује 49 одсто удела у Јат Еирвејс-у, а Јат Еирвејс постаје Авионик. Етихад и Влада Републике Србије обавезали су се да уложе по 40 милиона америчких долара, као и да обезбеде додатна средства у максималном износу од по 60 милиона долара. У октобру обављамо први лет за Абу Даби.",
        },
        {
          header: "2014",
          text: "За мање од годину дана од оснивања уводимо укупно 10 авиона типа Аирбус у наше јато - осам летелица типа А319 и две летелице типа А320. Први пут у дугој историји, нашим авионима почињу да управљају жене.",
        },
        {
          header: "2016",
          text: "У јуну Авионик уводи историјски, трансатлантски лет између Београда и Њујорка, чиме је поново успостављена директна веза између Србије и Сједињених Држава после 24 године.",
        },
        {
          header: "2020",
          text: "На основу уговора између Министарства привреде Владе Републике Србије и Авионика, извршена је докапитализација српске националне авио-компаније, при чему је Република Србија повећала свој власнички удео у Авионику са досадашњих 51 на 82 одсто, док је удео Етихад ервејза умањен са 49 на 18 одсто. Увећање основног капитала Друштва, предузето је у циљу отклањања поремећаја у привреди проузрокованих пандемијом заразне болести ЦОВИД-19.",
        },
      ],
    },
  ];

  return (
    <section className={styles["achievement-section"]}>
      <h4>Године за памћење</h4>
      <ul className={styles["achievement-list"]}>
        {achievementList.map((item, index) => (
          <AchievementItem key={item.title + index} item={item} />
        ))}
      </ul>
    </section>
  );
};

export default ThroughYears;
